/* eslint-disable complexity */

// var site = site || {};
(function ($) {
  Drupal.behaviors.filterableContentGridItemV1 = {
    imagePattern: 'mac_sku_PRODUCT_CODE_640x600_FILTER_VALUE',
    imageExtension: 'jpg',
    itemInlineTemplatePath: 'filterable_products_grid_partial_item_v1',
    prefilterSkus: [],
    nodes: {},
    selector: {
      prefilter: '.js-filterable-products__grid-item-prefilter',
      grid: '.js-filterable-products__grid',
      item: '.js-filterable-content__grid-item, .js-filterable-products__grid-item',
      container: '.js-filterable-products-block',
      ctaLink: '.js-filterable-content__grid-item--cta-url',
      productLink: '.js-filterable-content__grid-item--link',
      itemimage: '.js-filterable-content__grid-item--main-image'
    },

    cssClass: {
      hasResults: 'filterable-products-block--has-results'
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setup(context);
    },

    setup: function (context) {
      var self = this;
      var $grids = $(self.selector.grid, context);

      $grids.each(function () {
        var $this = $(this);

        self.getDom($this);
        self.setEvents($this);
      });
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$items = $(self.selector.item, $that);
      $that.nodes.$ctaLink = $(self.selector.ctaLink, $that.nodes.$items);
      $that.nodes.$productLink = $(self.selector.productLink, $that.nodes.$items);
      $that.nodes.$itemMainImage = $(self.selector.itemimage, $that.nodes.$items);
      $that.nodes.$container = $that.closest(self.selector.container);
      $that.nodes.$itemInline = $(
        'script.inline-template[path="' + self.itemInlineTemplatePath + '"]',
        $that.nodes.$container
      );
    },
    processTags: function (tagsData) {
      if (typeof tagsData !== 'string') {
        return [];
      }
      var newData = tagsData.replace(/['`~!@#$%^&*()|+=?;:'".<>\{\}\[\]\\\/]/gi, '').toLowerCase();
      // Loop through our tags, split them by comma, then trim the whitespace
      var tags = _.map(newData.split(','), $.trim);

      return tags;
    },
    setDefaultOrder: function ($that) {
      $that.nodes.$items.map(function (i, item) {
        var count = i + 1;

        $(item).data('default-order', count).attr('data-default-order', count);
      });
      if (!!$that.data('isotope')) {
        $that.isotope('updateSortData');
        $that.isotope('reloadItems');
      }
    },

    setEvents: function ($that) {
      var self = this;

      $that.nodes.$container.on('filterable_products:newItems', function () {
        self.getDom($that);
        self.setDefaultOrder($that);
      });
    },
    attached: false
  };
})(jQuery);
